import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import queryString from 'query-string';

import { API_URL as baseURL } from '^configs/environments';

const createBaseClient = (config?: AxiosRequestConfig): AxiosInstance => axios.create({
  baseURL,
  ...config,
  // axios v1 paramsSerializer object form. The serialized output is locked to the legacy
  // query-string@7 `arrayFormat: 'none'` contract (verified byte-identical, .migration/golden).
  paramsSerializer: {
    serialize: (params: Record<string, any>): string => (
      queryString.stringify(params, {
        arrayFormat: 'none',
      })
    ),
  },
});

const apiClient = createBaseClient();

const zipBaseURL = 'https://api.zippopotam.us/DK';

const createZipClient = (): AxiosInstance => axios.create({
  baseURL: zipBaseURL,
});

export const zipCodesClient = createZipClient();

export default apiClient;
